<template>
    <van-popup 
            v-model="showPopup"
            type="primary"
            class="my-popup"
            position="bottom"
            @close="doReject" @click-overlay="doReject"
        >
        <a href="javascript:;" class="close" @click="closePopup"><van-icon name="close" /></a>
        <div class="popup-title ta-center">
            <div class="fts-42"><strong><k-text :type="betType" /></strong></div>
            <strong>上证综指：<span v-if="transDate">{{pid}}</span> 期</strong>            
        </div>        
        <van-row type="flex" align="center"  class="fts-28">
            <van-col span="3">数额:</van-col>
            <van-col span="18">
                <div class="popGamUpInput">
                    <input type="number" v-model="betNum" maxlength="6" min = 1 max = 10000 placeholder="请输入下注数量" />
                </div>
            </van-col>
            <van-col span="3" class="ta-center">注</van-col>
        </van-row>
        <van-divider style="margin:0.05rem 0 0.15rem;" />
        <div class=""><span  class="fts-28">快速下注：</span><small>（1注=100金币）当前可投注<span class="cl-org">{{gold}}</span>金币</small></div>
        <div class="pd-v-sm">
            <a href="javascript:;" class="btn btn-zhu" @click="select(1)">1注</a>
            <a href="javascript:;" class="btn btn-zhu" @click="select(5)">5注</a>
            <a href="javascript:;" class="btn btn-zhu" @click="select(10)">10注</a>
            <a href="javascript:;" class="btn btn-zhu" @click="select(100)">100注</a>
            <a href="javascript:;" class="btn btn-zhu" @click="select(1000)">1000注</a>
            <a href="javascript:;" class="btn btn-zhu" @click="select(10000)">10000注</a>
            <br>
            <p>所需金币：<span class="red">{{totalCoin}}</span></p>            
        </div>
        <div class="popup-textarea-warp">
            <k-textarea placeholder="股神话大盘，涨的根据是什么？跌又是根据什么？" @on-change="textareName" :value="content" :rows="1" :max="500"></k-textarea>
        </div>
        <br/>
        <div class="ta-center btns">
            <van-button type="danger" @click="comfirm" block  v-if="betType==1">立刻下注</van-button>
            <van-button type="danger" @click="comfirm" block  v-if="betType==2">立刻下注</van-button>
        </div>
        <br/>
        <div class="small">
            <doc-goin></doc-goin>
        </div>
    </van-popup >
</template>
<script>
    import {mapGetters} from 'vuex'
    import DocGoin from '../../components/doc-goin'
    
    export default {
        data() {
            return {
                betNum : '',
                betType : 0,
                showPopup : false,
                resolve: null,
                reject: null,
                disabled : false,
                content: '',                
            }
        },
        components:{
            'doc-goin' : DocGoin,
        },
        computed: {
            ...mapGetters('home',['transDate']),
            ...mapGetters('account',['gold']),
            totalCoin(){
                return this.betNum*100
            },
            pid(){
                return this.transDate.replace(/-/g,'') || ''
            }
        },
        methods: {
            textareName(val){
                this.content = val
            },
            
            closePopup(){
                this.showPopup = false
                this.doReject()
            },
            select(item){
                this.betNum = item
                
            },
            comfirm(){
                if(!this.betNum){
                    this.$toast('请输入下注数量！')
                    return
                }
                if(this.totalCoin > this.gold){
                    this.$toast('您的金币数量不够！')
                    return
                }
                this.showPopup = false
                let {betNum, betType, pid, content} = this
                this.doResolve({
                    betNum, betType, pid, content
                })
            },
            show(type) {
                this.showPopup = true
                this.betType = type
                return new Promise((resolve, reject) => {
                    if (this.reject) {
                        this.reject()
                    }
                    this.resolve = resolve
                    this.reject = reject
                })
            },
            doResolve(val) {
                if (this.resolve) {
                    this.resolve(val)
                }
                this.clearPromiseState()
            },
            doReject() {
                if (this.reject) {
                    this.reject()
                }
                this.clearPromiseState()
            },
            clearPromiseState() {
                this.resolve = null
                this.reject = null
            }
        },
        watch : {
            betNum(n){
                if(n < 0) this.betNum = 1;
                if(n.length > 5) this.betNum = n.slice(0,5);
            },
            content(n){
                console.log(n)
            }
        }
    }
</script>
<style lang="less" scoped>
    .btns {
        .van-button {
            //width : 100%;
        }
    }
</style>